/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extraction_Status_CapturedInputs */

const en_extraction_status_captured = /** @type {(inputs: Extraction_Status_CapturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Extraction_Status_CapturedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const extraction_status_captured = /** @type {((inputs?: Extraction_Status_CapturedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extraction_Status_CapturedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_extraction_status_captured(inputs)
});